import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2rem;

  .set-withdraw-value__subtitle {
    font-size: 1.75rem;
    text-align: center;
    color: var(--blue00);
  }

  .set-withdraw-value__prefix-input-container {
    display: flex;
    align-items: center;

    width: 100%;
    min-height: 3.875rem;
    box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.16);

    border-radius: 1.75rem;
    padding: 0 2rem;

    &:focus-within {
      outline: 2px solid var(--grayad);
    }
  }

  .set-withdraw-value__currency-prefix {
    font-size: 1.25rem;
    font-weight: 400;

    color: var(--grayad);
  }

  .set-withdraw-value__input {
    background: transparent;
    border: none;
    outline: none;

    margin-left: 0.25rem;

    font-size: 1.25rem;
    font-weight: 400;
    flex: 1;

    color: var(--grayad);
  }

`
export const StyledReminderContainer = styled(Container)`
  max-width: 100%;
  margin-top: 10px;
`;

export const StyledReminder = styled.h3`
  font-size: 12.5px;
  font-weight: bold;
  margin-bottom: -20px;
  text-align: center;
  line-height: 1.5;
  word-break: break-word;
  word-spacing: 1px;
  font-family: 'Roboto', sans-serif;
  opacity: 0.8;
  color: var(--redad);
`;

export const StyledText = styled.h4`
font-size: 12px;
font-weight: normal;
margin-bottom: -20px;
text-align: center;
line-height: 1.5;
word-break: break-word;
word-spacing: 1px;
font-family: 'Roboto', sans-serif;
opacity: 0.8;
color: var(--grayad);
`;

export const StyledLink = styled.a`
  color: var(--blue00);
  text-decoration: underline;

  &:hover {
    text-decoration: none;
  }
`;

export const StyledGains = styled.h1`
text-align: center;
margin-bottom: 4px;
  }
`;


export const StyledError = styled.div`
  color: red;
  font-size: 14px;
  margin-top: 4px;
`;